// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDaysFromRegistrationCriteria = daysFromRegistration => ({
    daysFromRegistration,
    type: actions.UPDATE_DELIVERY_NO_DOCUMENTS_DAYS_CRITERIA
});

export const resetDeliveryNoDocumentsDaysCriteria = () => ({
    type: actions.RESET_DELIVERY_NO_DOCUMENTS_DAYS_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/action-creators/criteria.js